import { css } from '@emotion/react';
import { Colors } from '../../common/Colors';
import { helperTypographyText } from '../../helpers';
import { darkTheme } from './darkTheme';

export const stylesCommon = css`
  ${darkTheme};

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  ::selection {
    color: ${Colors.ut.bgDefault};
    background: ${Colors.ut.primary};
  }

  html {
    height: 100%;
    font-size: 10px;

    @media (max-width: 359px) {
      font-size: 9px;
    }
  }

  body {
    ${helperTypographyText({
      customColor: Colors.text.default
    })};

    min-width: 320px;
    height: 100%;
    background-color: ${Colors.ut.bgDefault};
  }

  a,
  button {
    transition-property: color, background-color;
    transition-duration: 0.25s;
  }

  img {
    vertical-align: middle;
    max-width: 100%;
    height: auto;
  }

  dd,
  dl {
    margin: 0;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
